import React from "react";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import moment from "moment/moment";
import classNames from "classnames";
import {Workflow} from "@commons/mapping/Workflow";
import WFIcons from "@components/WFIcons";
import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectUser} from "@commons/core.slice";

export const BannerWF: React.FC<{ richiesta: PresenzeCausaleWFRecord, lavoratore: LavoratoreBase, ope?: 'SHOW_UPDATE' | 'DELETE' | 'UPDATE_OR_INSERT' }> = ({richiesta, lavoratore, ope}) => {

    const giornoInizio = moment(richiesta.giornoInizio);
    const giornoFine = moment(richiesta.giornoFine);
    const bgColor = richiesta.wf.annullata ? 'bg-red-400' : 'bg-blue-100'
    const user: UserCRUDRecord | null = useAppSelector(selectUser); // User corrente

    return <div className={classNames(bgColor, 'p-4')}>
        <div className="container mx-auto font-medium grid gap-4 grid-cols-2 sm:grid-cols-5">
            {richiesta.wf.idWF !== 0 && <div className="row-span-2">
                Id workflow
                <br/>
                #{richiesta.wf.idWF}
            </div>}
            <div className="row-span-2">
                Id contratto
                <br/>
                #{richiesta.id}
            </div>
            <div className="row-span-2">
                Nominativo
                <br/>
                {richiesta.descrizione}
            </div>
            <div className="row-span-2">
                {giornoInizio.isSame(giornoFine) ? <>
                    Giorno di riferimento
                    <br/>
                    {giornoInizio.format('DD/MM/YYYY')}
                </> : <>
                    Periodo di riferimento
                    <br/>
                    {giornoInizio.format('DD/MM/YYYY') + ' - ' + giornoFine.format('DD/MM/YYYY')}
                </>}
            </div>
            {richiesta.wf.idWF !== 0 && <div className="row-span-2">
                Stato attuale
                <br/>
                <span className="inline-flex">
                    {(((lavoratore.codiceFiscale === user!.codiceFiscale) && !richiesta.wf.idWF) || (richiesta.wf.idWF !== 0 && richiesta.wf.idWF)) &&
                        <>
                            {Workflow.getDescrizioneStato(richiesta.wf.stato)}&nbsp;<WFIcons wfStato={richiesta.wf.stato!}/>
                        </>
                    }
                </span>
            </div>}

        </div>
    </div>;
}
export default BannerWF;